var map = {
	"./api-integration.png": 6693,
	"./aws-&-cloud-technology.png": 211,
	"./data-&-analytics-engineering.png": 7554,
	"./javascript.svg": 4831,
	"./next-js.png": 1705,
	"./payment-integration-&-ecommerce.svg": 6807,
	"./react-&-react-native.png": 692,
	"./ruby.png": 1894,
	"./software-development-life-cycle.png": 5631,
	"./sql.png": 9488,
	"./testing-&-debugging.png": 1482,
	"./typescript.svg": 5831,
	"./version-control.png": 3624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3663;